
<template>
  <div>
    <v-toolbar flat color="white">
      <!-- <v-toolbar-title>Perfis</v-toolbar-title>
      <v-spacer></v-spacer> -->

      <ServicesForm
        :addButton="true"
        :dialog="serviceDialog"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :saveService="(data) => saveService(data)"
        :editFormData="formData"
      />
    </v-toolbar>
    <SearchServices :searchServices="(service) => initialize(service)" />
    <v-data-table :headers="headers" :items="tableData">
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.service_name }}</td>
        <td class="text-xs-center">{{ props.item.created_at | moment("DD/MM/YYYY") }}</td>
        <td class="text-xs-center layout">
          <!-- v-if="profilesPermissions && profilesPermissions.edit" -->
          <v-icon small class="mr-2" @click="editItem(props.item)" v-if="permissions.edit">edit</v-icon>
          <!-- v-if="profilesPermissions && profilesPermissions.remove" -->
          <v-icon small @click="confirmDelService(props.item)" v-if="permissions.remove">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ServicesForm from './ServicesForm.vue'
import SearchServices from './SearchServices.vue'

export default {
  name: 'Services',

  components: {
    ServicesForm,
    SearchServices
  },

  data () {
    return {
      serviceDialog: false,
      formData: null,
      headers: [
        { text: 'Serviço', sortable: true, value: 'service_name' },
        {
          text: 'Data de criação do serviço',
          value: 'updated_at',
          sortable: false,
          align: 'center'
        },
        { text: ' ', value: '', sortable: false, align: 'center' }
      ],
      tableData: []
    }
  },

  mounted () {
    this.initialize()
  },
  computed: {
    permissions () {
      return this.$store.state.permissions.permissions.standardSystem
    }
  },
  methods: {
    confirmDelService (data) {
      let obj = {
        message: `Você deseja excluir o serviço "${data.service_name}"?`,
        title: 'Excluir serviço',
        callback: _ => {
          this.delService(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delService (data) {
      let obj = {
        url: '/api/standardService/' + data.id,
        query: '',
        method: 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Serviço removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.initialize()
      })
    },

    openDialogForm () {
      this.formData = null
      this.serviceDialog = true
    },

    closeDialogForm () {
      this.serviceDialog = false
    },

    initialize (service) {
      let dataSearch = {}
      if (service && service.service_name) {
        dataSearch.params = {
          ...service
        }
      }
      let obj = {
        url: '/api/standardService',
        query: dataSearch,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        this.tableData = response.data
      })
    },

    editItem (item, view) {
      // if (!item.permissions_id) {
      //   item.permissions_id = item.permissions.map(perm => {
      //     return perm.id;
      //   });
      // }
      view === 'viewForm' ? (item.view = true) : (item.view = false)
      this.formData = Object.assign({}, item)
      this.serviceDialog = true
    },

    saveService (data) {
      let id = data.id ? `/${data.id}` : ''
      let typeMethod = data.id ? 'patch' : 'post'

      // data.type = "master";
      // data.profile_id = 1;

      let obj = {
        url: '/api/standardService' + id,
        query: data,
        method: typeMethod
      }
      console.log(obj)
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Perfil ${id ? 'alterado' : 'criado'} com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.serviceDialog = false
        this.initialize()
      })
    }
  }
}
</script>
